import {
  DebriefFactSource,
  type DebriefFact,
  type DebriefStage,
} from '@momentum/types';
import type { EditableFact } from '../types';

export interface FactDraft {
  title: string;
  description: string;
  date?: string;
}

export type DebriefFactsAction =
  | { type: 'HYDRATE'; payload: DebriefFact[] }
  | {
      type: 'EDIT_FACT';
      payload: { id: string; draft: FactDraft };
    }
  | {
      type: 'ADD_FACT';
      payload: { stage: DebriefStage; draft: FactDraft };
    };

export interface DebriefFactsState {
  isHydrated: boolean;
  facts: EditableFact[];
}

export const initialDebriefFactsState: DebriefFactsState = {
  isHydrated: false,
  facts: [],
};

export function debriefFactsReducer(
  state: DebriefFactsState,
  action: DebriefFactsAction
): DebriefFactsState {
  switch (action.type) {
    case 'HYDRATE': {
      if (state.isHydrated) return state;
      return {
        isHydrated: true,
        facts: action.payload.map((fact) => ({
          ...fact,
          id: crypto.randomUUID(),
        })),
      };
    }
    case 'EDIT_FACT': {
      const { id, draft } = action.payload;
      return {
        ...state,
        facts: state.facts.map((fact) =>
          fact.id === id
            ? {
                ...fact,
                title: draft.title,
                description: draft.description,
                date: draft.date,
              }
            : fact
        ),
      };
    }
    case 'ADD_FACT': {
      const { stage, draft } = action.payload;
      const newFact: EditableFact = {
        id: crypto.randomUUID(),
        source: DebriefFactSource.Manual,
        title: draft.title,
        description: draft.description,
        link: '',
        stage,
        date: draft.date,
      };
      return { ...state, facts: [...state.facts, newFact] };
    }
    default:
      return state;
  }
}
